module.exports = __webpack_public_path__ + "annualreview2017/static/img/operations.3c55de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/operations.png
// module id = 301
// module chunks = 0